import { TFunctionResult } from "i18next"
import { observer } from "mobx-react-lite"

type TextVariant = "normal" | "normal-bold" | "large" | "large-bold" | "caption" | "small"

interface ITextProps {
	variant?: TextVariant
	style?: string
	children: string | number | TFunctionResult
}

const getVariantStyle = (variant: TextVariant) => {
	switch (variant) {
		case "caption": {
			return "text-[12px] font-italic text-gray-400"
		}
		case "normal-bold": {
			return "text-[17px] leading-[22px] font-semibold"
		}
		case "large": {
			return "text-[23px] leading-[25px]"
		}
		case "large-bold": {
			return "text-[23px] leading-[29px] font-bold"
		}
		case "small": {
			return "text-[13px] leading-[20px]"
		}
		case "normal":
		default: {
			return "text-[17px] leading-[22px]"
		}
	}
}

export const Text = observer(({ variant = "normal", style, children }: ITextProps) => {
	return <span className={"m-0 p-0 " + getVariantStyle(variant) + (style ? ` ${style}` : "")}>{children as string}</span>
})
